import { useState, useEffect, useCallback, useRef } from "react";
import axios from "axios";
import {
  Plus, Edit, Trash2, Eye, EyeOff, ChevronLeft, ChevronRight,
  Settings, Upload, AlertTriangle, UserPlus, User, List, X, Phone, Mail,
  Share2, Copy, Link, RotateCcw, ExternalLink, Download, QrCode, Ticket,
  Users, CheckCircle, XCircle, Wine, MessageCircle, RefreshCw
} from "lucide-react";
import { API, BACKEND_URL } from "@/config/api";
import PasswordInput from "@/components/common/PasswordInput";

const NewsletterTab = ({ credentials, events, fetchEvents, isGestor, gestorPrivileges, isSuperuser, setActiveTab }) => {
  const [newsletterSubscribers, setNewsletterSubscribers] = useState([]);
  const [loadingNewsletter, setLoadingNewsletter] = useState(false);

  const fetchNewsletterSubscribers = useCallback(async () => {
    setLoadingNewsletter(true);
    try {
      const response = await axios.get(`${API}/admin/newsletter-subscribers`, {
        headers: { Authorization: `Basic ${credentials}` }
      });
      setNewsletterSubscribers(response.data);
    } catch (e) {
      console.error("Error fetching newsletter subscribers:", e);
    } finally {
      setLoadingNewsletter(false);
    }
  }, [credentials]);

  useEffect(() => {
    fetchNewsletterSubscribers();
  }, [fetchNewsletterSubscribers]);

  return (
    <>
          <>
            <div className="form-section mb-8">
              <h3 className="form-title mb-6 flex items-center gap-2">
                <Mail size={20} className="text-green-400" />
                Suscriptores del Newsletter
              </h3>
              <p className="text-[var(--text-muted)] text-sm mb-6">
                Lista de usuarios que han aceptado recibir entradas automáticas cuando se crea un nuevo evento.
              </p>
              
              {loadingNewsletter ? (
                <div className="flex justify-center py-8">
                  <div className="spinner-large"></div>
                </div>
              ) : newsletterSubscribers.length === 0 ? (
                <div className="text-center py-8 text-[var(--text-muted)]">
                  No hay suscriptores del newsletter todavía
                </div>
              ) : (
                <>
                  <div className="bg-green-500/10 border border-green-500/30 p-4 mb-6 flex items-center justify-between">
                    <div>
                      <span className="text-green-400 font-bold text-2xl">{newsletterSubscribers.length}</span>
                      <span className="text-white ml-2">suscriptores VIP</span>
                    </div>
                    <button
                      onClick={fetchNewsletterSubscribers}
                      className="btn-download text-sm"
                    >
                      <RefreshCw size={14} className="inline mr-1" />
                      Actualizar
                    </button>
                  </div>
                  
                  <div className="overflow-x-auto">
                    <table className="w-full text-left">
                      <thead>
                        <tr className="border-b border-white/10">
                          <th className="pb-3 text-[var(--text-muted)] text-xs uppercase">Nombre</th>
                          <th className="pb-3 text-[var(--text-muted)] text-xs uppercase">Email</th>
                          <th className="pb-3 text-[var(--text-muted)] text-xs uppercase">Teléfono</th>
                          <th className="pb-3 text-[var(--text-muted)] text-xs uppercase">Género</th>
                          <th className="pb-3 text-[var(--text-muted)] text-xs uppercase">CP</th>
                          <th className="pb-3 text-[var(--text-muted)] text-xs uppercase">Estado</th>
                        </tr>
                      </thead>
                      <tbody>
                        {newsletterSubscribers.map((sub, idx) => (
                          <tr key={sub.id || idx} className="border-b border-white/5 hover:bg-white/5">
                            <td className="py-3 text-white font-medium">{sub.nombre}</td>
                            <td className="py-3 text-[var(--accent-cyan)]">{sub.email}</td>
                            <td className="py-3 text-[var(--text-muted)]">{sub.telefono || '-'}</td>
                            <td className="py-3 text-[var(--text-muted)] capitalize">{sub.genero || '-'}</td>
                            <td className="py-3 text-[var(--text-muted)]">{sub.codigo_postal || '-'}</td>
                            <td className="py-3">
                              {sub.activo ? (
                                <span className="text-green-400 text-xs bg-green-400/20 px-2 py-1 rounded">Activo</span>
                              ) : (
                                <span className="text-red-400 text-xs bg-red-400/20 px-2 py-1 rounded">Inactivo</span>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </>
              )}
            </div>
          </>

    </>
  );
};

export default NewsletterTab;
